module.exports = __webpack_public_path__ + "static/media/211.83190e30.png";